module.exports = __webpack_public_path__ + "media/zuopin3.1d0aef02.mp4";